import React from "react";
import Status from "../../../../model2/status/status";

type Props = {
    className?: string,
    status: Status,

    onCheckboxClick: onChangeCallback,
    checkboxStatus  : Status | null
}

export default function ColorBlock28(props: Props) {

    const curValueClasses = Classes('cur-value color-block-28 status-color-'+props.status.color );

    const checkboxClasses = Classes('checkbox',{
        'checked'   : props.checkboxStatus?.isOpen
    })

    return (
        <div className={curValueClasses}>
            {props.checkboxStatus &&
                <div className={checkboxClasses} onClick={props.onCheckboxClick}>
                    {props.checkboxStatus?.isOpen && <span className="i5-checkbox-ok"/>}
                </div>
            }
            <div className="name">{props.status.name}</div>
            <span className="i5-big-angle-down"> </span>

        </div>
    );
}
